import { Col, Row } from "antd";
import DeferredImage from "../deferred-image/deferred-image";

import "./reviews-section.css";

import reviews_00 from "./static/reviews_01.webp";
import reviews_01 from "./static/reviews_02.webp";
import reviews_02 from "./static/reviews_03.webp";
import reviews_03 from "./static/reviews_04.webp";
import reviews_04 from "./static/reviews_05.webp";
import reviews_05 from "./static/reviews_06.webp";
import reviews_06 from "./static/reviews_07.webp";
import reviews_07 from "./static/reviews_08.webp";
import { useMediaQuery } from "../../hooks/useMediaQuery";
import AppTitle from "../app-title/app-title";

const reviews = [
  { src: reviews_00, name: "Отзыв №1", width: 2270, height: 1040 },
  { src: reviews_01, name: "Отзыв №2", width: 2235, height: 1040 },
  { src: reviews_02, name: "Отзыв №3", width: 2321, height: 1040 },
  { src: reviews_03, name: "Отзыв №4", width: 1779, height: 1335 },
  { src: reviews_04, name: "Отзыв №5", width: 1801, height: 1337 },
  { src: reviews_05, name: "Отзыв №6", width: 1152, height: 554 },
  { src: reviews_06, name: "Отзыв №7", width: 2011, height: 1337 },
  { src: reviews_07, name: "Отзыв №8", width: 1143, height: 628 },
];

function ReviewsSection({ titleClassName = "" }) {
  const isMobileXl = useMediaQuery("xl");

  return (
    <>
      <AppTitle text={"Отзывы"} className={titleClassName} />
      {isMobileXl ? (
        <div className="horizontal-gallery reviews">
          <Row wrap={false}>
            <Col>
              <DeferredImage
                src={reviews[0].src}
                width={reviews[0].width}
                height={reviews[0].height}
                alt={reviews[0].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[1].src}
                width={reviews[1].width}
                height={reviews[1].height}
                alt={reviews[1].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[2].src}
                width={reviews[2].width}
                height={reviews[2].height}
                alt={reviews[2].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[4].src}
                width={reviews[4].width}
                height={reviews[4].height}
                alt={reviews[4].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[3].src}
                width={reviews[3].width}
                height={reviews[3].height}
                alt={reviews[3].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[7].src}
                width={reviews[7].width}
                height={reviews[7].height}
                alt={reviews[7].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[5].src}
                width={reviews[5].width}
                height={reviews[5].height}
                alt={reviews[5].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[6].src}
                width={reviews[6].width}
                height={reviews[6].height}
                alt={reviews[6].name}
                loading="lazy"
              />
            </Col>
          </Row>
        </div>
      ) : (
        <Row className="content reviews">
          <Row gutter={95} className="reviews1">
            <Col>
              <DeferredImage
                src={reviews[0].src}
                width={reviews[0].width}
                height={reviews[0].height}
                alt={reviews[0].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[1].src}
                width={reviews[1].width}
                height={reviews[1].height}
                alt={reviews[1].name}
                loading="lazy"
              />
            </Col>
            <Col>
              <DeferredImage
                src={reviews[2].src}
                width={reviews[2].width}
                height={reviews[2].height}
                alt={reviews[2].name}
                loading="lazy"
              />
            </Col>
          </Row>
          <Row gutter={[40, 48]} className="reviews2">
            <Col span={6}>
              <DeferredImage
                src={reviews[4].src}
                width={reviews[4].width}
                height={reviews[4].height}
                alt={reviews[4].name}
                loading="lazy"
              />
            </Col>
            <Col span={6}>
              <DeferredImage
                src={reviews[3].src}
                width={reviews[3].width}
                height={reviews[3].height}
                alt={reviews[3].name}
                loading="lazy"
              />
            </Col>
            <Col span={4} className="reviews-small">
              <Row>
                <DeferredImage
                    src={reviews[7].src}
                width={reviews[7].width}
                height={reviews[7].height}
                  alt={reviews[7].name}
                  loading="lazy"
                />
              </Row>
              <Row>
                <DeferredImage
                    src={reviews[5].src}
                width={reviews[5].width}
                height={reviews[5].height}
                  alt={reviews[5].name}
                  loading="lazy"
                />
              </Row>
            </Col>
            <Col span={6}>
              <DeferredImage
                src={reviews[6].src}
                width={reviews[6].width}
                height={reviews[6].height}
                alt={reviews[6].name}
                loading="lazy"
              />
            </Col>
          </Row>
        </Row>
      )}
    </>
  );
}

export default ReviewsSection;
